module.exports = __webpack_public_path__ + "res/status_icon.png";